<template>
  <div class="component-div">
    <!-- 2019.09.20 데이터 보유기간 input 컴포넌트 더블 클릭 제거, editing 고정 -->
    <div style="width:100%; display: flex; align-items: center;">
      <el-input-number style="width:50%;" :min="1" :max="targetData.count" ref="nameField" @change="modiEnter" v-model="targetData.basicinfoSubvalueInteger" controls-position="right">
      </el-input-number>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WInputComponent',
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      originValue: '',
    };
  },
  methods: {
    modiEnter() {
      this.$emit('check-change-flag');
    },
    // column data formatter
    formatter(row, column, value) {
      return `${value}${row.basicinfoSubunit}`;
    },
  },
};
</script>

<style>
.component-div{
  display: flex;
  width: 100%;
  height: 100%;
  padding: 4px;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/DataRetentionRange/components/inputComponent.vue